<div class="consent-card">
  <div class="head-text">
    Construction Pathways Experience Portal Student Account Creation
  </div>

  <div class="d-grid gap-3">
    <div class="secondary-head-text" style="font-size: 16px">
      Student details
    </div>

    <div class="grid-container">
      <div class="d-grid gap-1">
        <div class="primary-label">Student name</div>
        <div class="secondary-label">{{ studentData?.studentName }}</div>
      </div>
      <div class="d-grid gap-1">
        <div class="primary-label">Date of birth</div>
        <div class="secondary-label">
          {{ studentData?.dateOfBirth | date: "dd/MM/yyyy" }}
        </div>
      </div>
      <div class="d-grid gap-1 print-only">
        <div class="primary-label">School name</div>
        <div class="secondary-label">{{ studentData?.schoolName || '-' }}</div>
      </div>
    </div>

    <div class="secondary-label">
      For more information on what this consent covers, please refer to the
      section at the bottom of this page - Account Creation Consent.
    </div>
  </div>

  <div class="d-grid gap-3">
    <div class="secondary-head-text">
      By selecting approve you confirm the below is correct and consented:
    </div>

    <div class="list">
      <li>You are the parent/guardian of the student.</li>
      <li>The above student information is accurate.</li>
      <li>
        You give permission for the student's information to be collected and
        stored securely by CSQ
      </li>
      <li>
        You acknowledge that CSQ is committed to protecting the privacy and
        confidentiality of all information.
      </li>
    </div>
  </div>

  <div class="d-grid gap-3">
    <div class="secondary-head-text">
      And you understand that this information will be used only for:
    </div>

    <div class="list">
      <li>Student onboarding</li>
      <li>Event participation</li>
      <li>Analytics and reporting</li>
    </div>
  </div>

  <div *ngIf="showAccountApproval">
    <app-input
      context="Normal"
      label="Approval"
      placeholder="Select"
      type="select"
      [control]="form.get('approval')"
      [options]="dataOption"
      [customErrorMessages]="{
        required: 'Please select an option.',
      }"
      bgColor="#232323"
    >
    </app-input>
    <div *ngIf="form.get('approval')?.value" class="small-text">
      <ng-container *ngIf="studentData?.accountUpdatedBy; else accountSelection">
        <span
          [ngClass]="
            form.get('approval')?.value === 'approve' ? 'apv-text' : 'decl-text'
          "
          >{{
            form.get("approval")?.value === "approve" ? "Approved" : "Declined"
          }}
          by :
        </span>
        {{ studentData?.accountUpdatedBy }}
      </ng-container>
      <ng-template #accountSelection>
        <span class="selected-text">
          Selected:
          {{ form.get("approval")?.value === "approve" ? "Approved" : "Declined" }}
        </span>
      </ng-template>
    </div>
  </div>

  <div
    *ngIf="showMediaApproval"
    class="d-grid gap-3"
  >
    <div class="primary-head-text text-center">
      Media consent
    </div>

    <div class="secondary-label">
      I agree to providing consent to the use of the student's information
      (image, sound recording or name under the Privacy Act 1988 (Cth) for a
      period of twelve (12) months, by clicking 'Approve' I am effectively
      providing my signature.
    </div>

    <div class="secondary-label">
      For more information on what this consent covers, please refer to the
      section at the bottom of this page – Media Consent.
    </div>

    <div>
      <app-input
        context="Normal"
        label="Approval"
        placeholder="Select"
        type="select"
        [control]="form.get('secondapproval')"
        [options]="dataOption"
        [disabled]="false"
        [customErrorMessages]="{
          required: 'Please select an option.',
        }"
        bgColor="#232323"
      >
      </app-input>
      <div *ngIf="form.get('secondapproval')?.value" class="small-text">
        <ng-container *ngIf="studentData?.mediaConsentUpdatedBy; else mediaSelection">
          <span
            [ngClass]="
              form.get('secondapproval')?.value === 'approve' ? 'apv-text' : 'decl-text'
            "
            >{{
              form.get("secondapproval")?.value === "approve"
                ? "Approved"
                : "Declined"
            }}
            by :
          </span>
          {{ studentData?.mediaConsentUpdatedBy ?? "" }}
        </ng-container>
        <ng-template #mediaSelection>
          <span class="selected-text">
            Selected:
            {{
              form.get("secondapproval")?.value === "approve"
                ? "Approved"
                : "Declined"
            }}
          </span>
        </ng-template>
      </div>
    </div>
  </div>

  <div
    class="pb-5 pt-3 d-flex align-items-center justify-content-center border-bottom"
    *ngIf="showMediaApproval"
    [style.opacity]="isMediaConsentWaitingForAccountSelection ? '0.5' : '1'"
    [style.pointer-events]="
      isMediaConsentWaitingForAccountSelection ? 'none' : 'auto'
    "
  >
    <button
      class="submit-btn"
      (click)="updateApprovalStatus(true)"
      [disabled]="form.invalid || isSubmitted || hasSubmittedDecision"
      [style.opacity]="form.invalid || isSubmitted || hasSubmittedDecision ? '0.5' : '1'"
      [style.cursor]="form.invalid || isSubmitted || hasSubmittedDecision ? 'not-allowed' : 'pointer'"
    >
      Submit consent
    </button>
  </div>

  <div *ngIf="!showMediaApproval" class="d-grid gap-3 border-bottom">
    <div class="py-4 d-flex align-items-center justify-content-center">
      <button
        class="submit-btn"
        (click)="updateApprovalStatus(true)"
        [disabled]="form.get('approval')?.invalid || isSubmitted || hasSubmittedDecision"
        [style.opacity]="
          form.get('approval')?.invalid || isSubmitted || hasSubmittedDecision ? '0.5' : '1'
        "
        [style.cursor]="
          form.get('approval')?.invalid || isSubmitted || hasSubmittedDecision
            ? 'not-allowed'
            : 'pointer'
        "
      >
        Submit consent
      </button>
    </div>

    <div class="secondary-label" *ngIf="!isStudent">
      If your child is 16 or older today, they will be requested to provide
      their own consent for the use of their image, name, or recordings under
      the Privacy Act 1988 (Cth) for a period of 12 months.
    </div>
    <div class="secondary-label pb-4" *ngIf="!isStudent">
      As part of the CSQ program, we may request consent to use your child's
      work, images, audio or video recordings, and name in CSQ materials. This
      may include promotional or educational content such as websites,
      brochures, videos, social media, reports, and other communications.
    </div>
  </div>

  <div class="d-grid gap-3">
    <div class="contain-text">Account Creation Consent</div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">1. Data Collection & Purpose</div>
      <div class="secondary-label">
        We collect personal information through our online portal, including
        name, email address, telephone number, addresses etc to manage your
        account, provide access to services, facilitate, and improve user
        experience.
      </div>
      <div class="secondary-label">
        Your personal information will only be used or disclosed for the primary
        purpose for which it was collected, or for directly related purposes,
        unless you consent or it is authorized by law.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">2. Data Storage & Security</div>
      <div class="secondary-label">
        We store your personal information in both physical and electronic
        forms, using secure servers and cloud-based systems protected by robust
        industry-standard security measures.
      </div>
      <div class="secondary-label">
        We take all reasonable steps—including SSL encryption, firewalls, and
        password protection to protect the personal information held in our
        portal from misuse, interference, loss, unauthorized access,
        modification, or disclosure.
      </div>
      <div class="secondary-label">
        You are responsible for keeping your username and password safe. Do not
        share your credentials, and please ensure you log out of the portal
        after each session.
      </div>
      <div class="secondary-label">
        For your security, the portal will automatically log you out after 15
        minutes of inactivity.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">3. Data Retention & Destruction</div>
      <div class="secondary-label">
        We will only retain your personal information for as long as it is
        required to fulfill the purposes set out in this policy, or as required
        by law.
      </div>
      <div class="secondary-label">
        Once your personal information is no longer needed for our business
        purposes or legal obligations, we will take reasonable steps to securely
        destroy or permanently de-identify it.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">4. Data Breach Notification</div>
      <div class="secondary-label">
        In the event of a data breach, we will comply with applicable laws, and
        regulations, and will notify affected individuals and relevant
        authorities if the breach poses a likely risk of serious harm.In the
        event of a data breach, we will comply with applicable laws, and
        regulations, and will notify affected individuals and relevant
        authorities if the breach poses a likely risk of serious harm.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">5. User Rights & Contact</div>
      <div class="secondary-label">
        You have the right to access, correct, or request deletion of the
        personal information we hold about you. You can update your information
        by logging into your account or by contacting us at
        {{ "constructionpathways@csq.org.au" }}
      </div>
    </div>
  </div>

  <div class="d-grid gap-3" *ngIf="showMediaApproval">
    <div class="contain-text">Media Consent</div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">1. General Background</div>
      <div class="secondary-label">
        The consent given extends to use of the student's copyright material,
        image, sound recording and name in whole or part and digital adaptations
        used alone or in conjunction with words, drawings and other images. This
        material can appear in television advertising, video, brochures, forms,
        public relations display, annual reports, press advertising, internal
        documents such as manuals, web sites, certificates, strategic plan,
        posters and promotional material and in materials produced by
        Construction Skills Queensland.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">2. What is copyright material?</div>
      <div class="secondary-label">
        Copyright material may include the student's written work (e.g., stories
        and poems), paintings, pictures, drawings, designs, photographs, videos,
        films, music, performance, computer program, emails, web sites,
        sculptures, metal or wood works that a student creates in the course of
        his/her studies during the time he/she is enrolled in the CSQ program.
        These materials may form part of the student's academic assessment or be
        part of his/her studies generally and may attract copyright. CSQ
        understands that the student owns the intellectual property rights for
        his/her material and that this consent form is not meant to transfer
        his/her ownership - simply that CSQ has the permission to use the
        student's materials for the purposes mentioned.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">3. What is an image or recording?</div>
      <div class="secondary-label">
        An image or recording referred to in this consent form includes
        photographs, emails, videos, films, or sound recordings of the student.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">
        4. What happens to this consent form once it is signed?
      </div>
      <div class="secondary-label">
        This consent form is retained by CSQ which is placed on the student's
        file. The student or the parent/guardian, if the student is under 18
        years of age, may request a copy of the signed consent form by
        contacting CSQ.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">
        5. How long will this consent be in effect?
      </div>
      <div class="secondary-label">
        The consent will be effective until the student or parent/guardian, if
        the student is under 18 years of age, revokes the consent.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">
        6. What if the student or the parent/guardian, if the student is under
        18 years of age, wishes to withdraw the consent?
      </div>
      <div class="secondary-label">
        Consent can be modified or withdrawn at any time by writing to CSQ.
        However, any changes will apply only from the date of the receipt by CSQ
        of any consent withdrawal. Any existing material will not be withdrawn
        from use if CSQ is currently using the material or where CSQ has entered
        into contractual obligations in relation to this material. In such cases
        the withdrawal will be effective after CSQ has entered into contractual
        obligations in relation to this material. In such cases the withdrawal
        will be effective after CSQ's use is complete or after the contractual
        obligations come to an end.
      </div>
    </div>
    <div class="d-grid gap-2">
      <div class="primary-head-text">
        7. What if the student or the parent/guardian does not want to give
        consent?
      </div>
      <div class="secondary-label">
        The student or the parent/guardian may refuse to give consent in which
        case the student will be omitted from any media that CSQ uses.
      </div>
    </div>

    <div class="d-grid gap-2">
      <div class="primary-head-text">8. Privacy</div>
      <div class="secondary-label">
        Consent to the use of the student's personal information (image, sound
        recording or name) under the Privacy Act 1988 (Cth).
      </div>
    </div>
  </div>

  <div class="footer-section">
    <img src="assets/images/Logo/login-logo.svg" alt="CSQ Logo" class="logo" />

    <div class="mascot-container">
      <div class="mascot-img-content">
        <a
          href="https://www.tiktok.com/@constructionpathways"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper tiktok">
            <img
              src="assets/images/tiktok-logo.svg"
              alt="tiktok"
              class="mascot-icon"
            />
          </div>
        </a>

        <a
          href="https://www.instagram.com/constructionpathways/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper instagram">
            <img
              src="assets/images/instagram-logo.svg"
              alt="instagram"
              class="mascot-icon"
            />
          </div>
        </a>

        <a
          href="https://www.facebook.com/constructionpathways"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mascot-icon-wrapper facebook">
            <img
              src="assets/images/facebook-logo.svg"
              alt="facebook"
              class="mascot-icon"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
